import { render } from "./GeneralButtonComponent.vue?vue&type=template&id=7952baaa&scoped=true"
import script from "./GeneralButtonComponent.vue?vue&type=script&lang=js"
export * from "./GeneralButtonComponent.vue?vue&type=script&lang=js"

import "./GeneralButtonComponent.vue?vue&type=style&index=0&id=7952baaa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7952baaa"]])

export default __exports__